export function initializePersonalice({ organization, scopes }) {
  const theName = scopes?.filter((scope) => scope.scope === 'name_backoffice');
  const organizationName = organization?.tenant?.name || process.env.REACT_APP_WEBSITE_NAME;

  document.title = theName?.length > 0 ? theName[0].json : organizationName;
}
